import React from 'react';
import {
  LocalizedLink,
  getDebugLinkStyleIfInvalid,
} from '@repo/gatsby-localization-helpers';

interface LinkComponentProps
  extends Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  children?: React.ReactNode;
  to?: string;
  href?: string;
  onKeyDown?: React.KeyboardEventHandler<HTMLAnchorElement>;
  onBlur?: React.FocusEventHandler<HTMLAnchorElement>;
}

function LinkComponent({
  children = null,
  to,
  href,
  ...props
}: Readonly<LinkComponentProps>) {
  const isInternalLink = /^\/(?!\/)/.test(to);

  if (!isInternalLink)
    return (
      <a
        href={to || href}
        style={getDebugLinkStyleIfInvalid({ to, href, ...props })}
        {...props}
      >
        {children}
      </a>
    );

  return (
    to && (
      <LocalizedLink to={to} {...props}>
        {children}
      </LocalizedLink>
    )
  );
}

export default LinkComponent;
